<!--供应商 -->
<template>
	<div class="wrap">

		<div class="header-wrap">

			<div class="header">
				<img src="../assets/return.png" class="return-img" @click="$router.back()">
				<div class="search-bar" @click="$router.push('/search?type=4')">
					<img src="../assets/search-icon.png" class="search-icon">
					<input placeholder="请输入搜索关键字" class="search-input" />
				</div>
			</div>

			<ul class="tab-list">
				<li :class="{active: tabIndex === 0}" @click="tabIndex = 0">推荐</li>
				<li :class="{active: tabIndex === 1}" @click="tabIndex = 1">全部</li>
			</ul>
		</div>

		<!-- 推荐 -->
    <supplier-recommend v-if="tabIndex === 0"/>

		<!-- 全部 -->
		<supplier-classification v-if="tabIndex === 1"/>

	</div>
</template>

<script>
	import SupplierRecommend from "@/components/supplier/supplier-recommend";
  import SupplierClassification from "@/components/supplier/supplier-classification";
  export default {
    components: {SupplierClassification, SupplierRecommend},
    data() {
			return {
        tabIndex: 0,
			};
		},
		mounted() {

		},
		methods: {

		},
	}
</script>

<style scoped>
	/* 头部样式 */
	.header-wrap {
		width: 100%;
		height: 84px;
		display: flex;
		flex-direction: column;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 500;
		background-color: #FFFFFF;
	}

	.header {
		width: 100%;
		height: 44px;
		display: flex;
		align-items: center;
		background-color: #FFFFFF;
		z-index: 499;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.return-img {
		width: 20px;
		margin-right: 10px;
	}

	.search-bar {
		width: calc(100% - 65px);
		height: 36px;
		background-color: #F3F3F3;
		border-radius: 100px;
		display: flex;
		align-items: center;
		padding: 0 10px;
		box-sizing: border-box;
	}

	.search-icon {
		width: 16px;
		margin-right: 10px;
	}

	.search-input {
		flex: 1;
		font-size: 15px;
	}

	.search-input::placeholder {
		color: #B6B6B6;
	}

	.tab-list {
		width: 100%;
		height: 40px;
		display: flex;
		align-items: center;
		position: relative;
	}
	.tab-list>li {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 40px;
		line-height: 40px;
		font-size: 16px;
		color: #888888;
		position: relative;
	}

	.tab-list>li.active {
		font-size: 18px;
		font-weight: 500;
		color: #222222;
	}

	.tab-list>li.active::after {
		content: "";
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translate(-50%, 0);
		background: linear-gradient(90deg, #2A63F3, #81B8FF);
		border-radius: 2px;
		width: 18px;
		height: 4px;
	}

	.wrap {
		width: 100%;
		height: calc(var(--vh) * 100 - 84px);
		display: flex;
		flex-direction: column;
		margin: 84px 0 0;
		box-sizing: border-box;
		background-color: #F4F4F4;
		overflow: auto;
	}
</style>
